import { render } from "./day-two-lunch.vue?vue&type=template&id=1797fce2"
import script from "./day-two-lunch.vue?vue&type=script&lang=js"
export * from "./day-two-lunch.vue?vue&type=script&lang=js"
script.render = render

export default script